export const initialBusinessLines = [
  {
    id: "VM08",
    type: "businessLine",
    name: "Life Science",
    legacyName: "Life Science",
    value: "VM08",
    isOem: 0,
    isHidden: 0,
    parents: [],
    customizations: ""
  },
  {
    id: "8FABRIMET",
    type: "marketSegment",
    name: "Fabric. Metal Manuf.",
    legacyName: "Fabric. Metal Manuf.",
    value: "8FABRIMET",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "8FOOD",
    type: "marketSegment",
    name: "Food/Feed/Agricult.",
    legacyName: "Food/Feed/Agricult.",
    value: "8FOOD",
    isOem: 0,
    isHidden: 0,
    parents: ["VM08", "VM09", "VM10", "VM11"],
    customizations: ""
  },
  {
    id: "8CLINIC",
    type: "marketSegment",
    name: "Hospital",
    legacyName: "Clinic/Hospital",
    value: "8CLINIC",
    isOem: 0,
    isHidden: 0,
    parents: ["VM08", "VM10"],
    customizations: ""
  },
  {
    id: "8INFRA",
    type: "marketSegment",
    name: "Infrastr./Architect.",
    legacyName: "Infrastr./Architect.",
    value: "8INFRA",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "8INSPEC",
    type: "marketSegment",
    name: "Inspec/Lab/Rent Serv",
    legacyName: "Inspec./Lab/Rental",
    value: "8INSPEC",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "8EQUIPMENT",
    type: "marketSegment",
    name: "Medical Device/Equip",
    legacyName: "Med.Device/Equipment",
    value: "8EQUIPMENT",
    isOem: 0,
    isHidden: 0,
    parents: ["VM08", "VM10"],
    customizations: ""
  },
  {
    id: "8METAL",
    type: "marketSegment",
    name: "Metal Manufacturing",
    legacyName: "Metal Manufacturing",
    value: "8METAL",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "8GEO",
    type: "marketSegment",
    name: "Mining/Geology",
    legacyName: "Mining/Geology",
    value: "8GEO",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "8NONDURA",
    type: "marketSegment",
    name: "Non-Durable Goods",
    legacyName: "Non-Durable Goods",
    value: "8NONDURA",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "8NONMETAL",
    type: "marketSegment",
    name: "Nonmetal Min Manuf",
    legacyName: "NonMet.Mineral Manuf",
    value: "8NONMETAL",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "VM09",
    type: "businessLine",
    name: "Industry",
    legacyName: "Material Science",
    value: "VM09",
    isOem: 0,
    isHidden: 0,
    parents: [],
    customizations: ""
  },
  {
    id: "8OIL-GAS",
    type: "marketSegment",
    name: "Oil & Gas",
    legacyName: "Oil & Gas",
    value: "8OIL-GAS",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "8PHARMA",
    type: "marketSegment",
    name: "Pharmaceutical",
    legacyName: "Pharmaceutical",
    value: "8PHARMA",
    isOem: 0,
    isHidden: 0,
    parents: ["VM08", "VM10"],
    customizations: ""
  },
  {
    id: "8RAIL",
    type: "marketSegment",
    name: "Rail/Railway/Vessel",
    legacyName: "Railway/Vessel",
    value: "8RAIL",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "8RECYCLING",
    type: "marketSegment",
    name: "Recycling",
    legacyName: "Recycling",
    value: "8RECYCLING",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "8EDUCATION",
    type: "marketSegment",
    name: "Train Fac/Teach Lab",
    legacyName: "Education",
    value: "8EDUCATION",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "7",
    type: "application",
    name: "Alloy : Precious metals recycling",
    legacyName: "Alloy : Precious Metals Recycling",
    value: 7,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8GEO", "8RECYCLING"],
    customizations: ""
  },
  {
    id: "13",
    type: "application",
    name: "Alloy : Recycling",
    legacyName: "Alloy : Recycling",
    value: 13,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8GEO", "8RECYCLING"],
    customizations: ""
  },
  {
    id: "1",
    type: "application",
    name: "Automotive Body/Engine",
    legacyName: "Automotive Body/Engine",
    value: 1,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "8",
    type: "application",
    name: "Aviation Airframe/Engine",
    legacyName: "Aviation Airframe/Engine",
    value: 8,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "3",
    type: "application",
    name: "Bioscience education",
    legacyName: "BIOSCIENCE EDUCATION",
    value: 3,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8CLINIC", "8EDUCATION"],
    customizations: ""
  },
  {
    id: "VM10",
    type: "businessLine",
    name: "OEM Life Science",
    legacyName: "",
    value: "VM10",
    isOem: 1,
    isHidden: 0,
    parents: [],
    customizations: ""
  },
  {
    id: "14",
    type: "application",
    name: "Carbon/Composites",
    legacyName: "Carbon/Composites",
    value: 14,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "19",
    type: "application",
    name: "Casting",
    legacyName: "Casting",
    value: 19,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "5",
    type: "application",
    name: "Cell biology - Cancer research",
    legacyName: "",
    value: 5,
    isOem: 0,
    isHidden: 0,
    parents: ["8BIOTEC", "8CLINIC", "8PHARMA"],
    customizations: ""
  },
  {
    id: "11",
    type: "application",
    name: "Cell biology - General",
    legacyName: "",
    value: 11,
    isOem: 0,
    isHidden: 0,
    parents: ["8BIOTEC", "8CLINIC", "8PHARMA"],
    customizations: ""
  },
  {
    id: "4",
    type: "application",
    name: "Cell culturing",
    legacyName: "CELL CULTURING",
    value: 4,
    isOem: 0,
    isHidden: 0,
    parents: ["8BIOTEC"],
    customizations: ""
  },
  {
    id: "23",
    type: "application",
    name: "Chemical/Plastics/Rubber",
    legacyName: "Chemical/Plastics/Rubber",
    value: 23,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "17",
    type: "application",
    name: "Coatings",
    legacyName: "Coatings",
    value: 17,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8OIL-GAS",
      "8PHARMA",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "30",
    type: "application",
    name: "Consumer goods",
    legacyName: "Consumer Goods",
    value: 30,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "21",
    type: "application",
    name: "Corrosion",
    legacyName: "Corrosion",
    value: 21,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "2",
    type: "application",
    name: "Cytogenetics",
    legacyName: "CYTOGENETICS",
    value: 2,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8CLINIC"],
    customizations: ""
  },
  {
    id: "VM11",
    type: "businessLine",
    name: "OEM Industry",
    legacyName: "",
    value: "VM11",
    isOem: 1,
    isHidden: 0,
    parents: [],
    customizations: ""
  },
  {
    id: "25",
    type: "application",
    name: "Education",
    legacyName: "Education",
    value: 25,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "33",
    type: "application",
    name: "Electronic device",
    legacyName: "Electronic Device",
    value: 33,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "28",
    type: "application",
    name: "Flaw detection",
    legacyName: "FLAW DETECTION",
    value: 28,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "31",
    type: "application",
    name: "Fluids & Oils",
    legacyName: "Fluids & Oils",
    value: 31,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8OIL-GAS",
      "8PHARMA",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "34",
    type: "application",
    name: "Gear box",
    legacyName: "Gear Box",
    value: 34,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "18",
    type: "application",
    name: "Geology : Geological surveys",
    legacyName: "Geology : Geological Surveys",
    value: 18,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8GEO", "8RECYCLING"],
    customizations: ""
  },
  {
    id: "38",
    type: "application",
    name: "Glass/Ceramic",
    legacyName: "Glass/Ceramic",
    value: 38,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "36",
    type: "application",
    name: "ID Tubing",
    legacyName: "ID Tubing",
    value: 36,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "16",
    type: "application",
    name: "Immunology",
    legacyName: "IMMUNOLOGY",
    value: 16,
    isOem: 0,
    isHidden: 0,
    parents: ["8BIOTEC", "8CLINIC", "8PHARMA"],
    customizations: ""
  },
  {
    id: "41",
    type: "application",
    name: "Industrial scientific research",
    legacyName: "Industrial Scientific research",
    value: 41,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "8AERO",
    type: "marketSegment",
    name: "Aerospace",
    legacyName: "Aerospace",
    value: "8AERO",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "39",
    type: "application",
    name: "Infrastructure",
    legacyName: "Infrastructure",
    value: 39,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "42",
    type: "application",
    name: "Integrators",
    legacyName: "INTEGRATORS",
    value: 42,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "9",
    type: "application",
    name: "IVF",
    legacyName: "IVF",
    value: 9,
    isOem: 0,
    isHidden: 0,
    parents: ["8CLINIC", "8DIAGNOST"],
    customizations: ""
  },
  {
    id: "43",
    type: "application",
    name: "Machined parts",
    legacyName: "Machined Parts",
    value: 43,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "10",
    type: "application",
    name: "Medical education",
    legacyName: "MEDICAL EDUCATION",
    value: 10,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8CLINIC", "8EDUCATION"],
    customizations: ""
  },
  {
    id: "44",
    type: "application",
    name: "Metallography/Metallurgy",
    legacyName: "METALLOGRAPHY/ METALLURGY",
    value: 44,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "22",
    type: "application",
    name: "Mining : Environmental & Rehabilitation",
    legacyName: "Mining : Environmental & Rehabilitation",
    value: 22,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8GEO", "8RECYCLING"],
    customizations: ""
  },
  {
    id: "26",
    type: "application",
    name: "Mining : Exploration",
    legacyName: "Mining : Exploration",
    value: 26,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8GEO", "8RECYCLING"],
    customizations: ""
  },
  {
    id: "29",
    type: "application",
    name: "Mining : Processing, Refining & Metallurgy",
    legacyName: "Mining : Processing, Refining & Metallur",
    value: 29,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8GEO", "8RECYCLING"],
    customizations: ""
  },
  {
    id: "32",
    type: "application",
    name: "Mining : Production & Grade control",
    legacyName: "Mining : Production & Grade Control",
    value: 32,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8GEO", "8RECYCLING"],
    customizations: ""
  },
  {
    id: "8AUTO",
    type: "marketSegment",
    name: "Automotive",
    legacyName: "Automotive",
    value: "8AUTO",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "20",
    type: "application",
    name: "Neuroscience",
    legacyName: "Neuroscience",
    value: 20,
    isOem: 0,
    isHidden: 0,
    parents: ["8BIOTEC", "8CLINIC", "8PHARMA"],
    customizations: ""
  },
  {
    id: "15",
    type: "application",
    name: "Pathology",
    legacyName: "Pathology/Cytology/Hematology",
    value: 15,
    isOem: 0,
    isHidden: 0,
    parents: ["8CLINIC", "8DIAGNOST"],
    customizations: ""
  },
  {
    id: "24",
    type: "application",
    name: "Physiology",
    legacyName: "PHYSIOLOGY",
    value: 24,
    isOem: 0,
    isHidden: 0,
    parents: ["8BIOTEC", "8CLINIC", "8PHARMA"],
    customizations: ""
  },
  {
    id: "46",
    type: "application",
    name: "Pipelines",
    legacyName: "Pipelines",
    value: 46,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "6",
    type: "application",
    name: "PMI",
    legacyName: "PMI",
    value: 6,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "48",
    type: "application",
    name: "Process piping",
    legacyName: "Process piping",
    value: 48,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "50",
    type: "application",
    name: "Processing, Refining & Metallurgy",
    legacyName: "Processing, Refining & Metallurgy",
    value: 50,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "40",
    type: "application",
    name: "Regulatory : Environment - Other",
    legacyName: "Regulatory : Enviro-Other",
    value: 40,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8GEO", "8RECYCLING"],
    customizations: ""
  },
  {
    id: "35",
    type: "application",
    name: "Regulatory : Environment - Soil",
    legacyName: "Regulatory : Enviro-Soil",
    value: 35,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8GEO", "8RECYCLING"],
    customizations: ""
  },
  {
    id: "37",
    type: "application",
    name: "Regulatory : Lead paint",
    legacyName: "Regulatory : Lead Paint",
    value: 37,
    isOem: 0,
    isHidden: 0,
    parents: ["8DIAGNOST", "8GEO", "8RECYCLING"],
    customizations: ""
  },
  {
    id: "8BIOTEC",
    type: "marketSegment",
    name: "Biotech",
    legacyName: "Biotech",
    value: "8BIOTEC",
    isOem: 0,
    isHidden: 0,
    parents: ["VM08", "VM10"],
    customizations: ""
  },
  {
    id: "51",
    type: "application",
    name: "Security",
    legacyName: "Security",
    value: 51,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "45",
    type: "application",
    name: "Semiconductor",
    legacyName: "Semiconductor",
    value: 45,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "27",
    type: "application",
    name: "Stem Cell / RM",
    legacyName: "Stem Cell Research",
    value: 27,
    isOem: 0,
    isHidden: 0,
    parents: ["8BIOTEC", "8CLINIC", "8PHARMA"],
    customizations: ""
  },
  {
    id: "47",
    type: "application",
    name: "Tube/Rod/Bar/Sheet Metal",
    legacyName: "Tube/Rod/Bar/Sheet Metal",
    value: 47,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "49",
    type: "application",
    name: "Turbine",
    legacyName: "Turbine",
    value: 49,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8AUTO",
      "8CHEM",
      "8FABRIMET",
      "8FOOD",
      "8EQUIPMENT",
      "8METAL",
      "8NONDURA",
      "8NONMETAL",
      "8PHARMA",
      "8RAIL"
    ],
    customizations: ""
  },
  {
    id: "52",
    type: "application",
    name: "Turbine - Large aviation",
    legacyName: "Turbine - large aviation",
    value: 52,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "53",
    type: "application",
    name: "Turbine - Power",
    legacyName: "Turbine – power",
    value: 53,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "54",
    type: "application",
    name: "Turbine - Small aviation",
    legacyName: "Turbines - small aviation",
    value: 54,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "55",
    type: "application",
    name: "Vessels",
    legacyName: "Vessels",
    value: 55,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "56",
    type: "application",
    name: "Weld inspection",
    legacyName: "Weld Inspection",
    value: 56,
    isOem: 0,
    isHidden: 0,
    parents: [
      "8AERO",
      "8CHEM",
      "8FOOD",
      "8INFRA",
      "8INSPEC",
      "8NONDURA",
      "8OIL-GAS",
      "8RAIL",
      "8EDUCATION"
    ],
    customizations: ""
  },
  {
    id: "8CHEM",
    type: "marketSegment",
    name: "Chem/Petrochem/Plast",
    legacyName: "Chemical/Plastics",
    value: "8CHEM",
    isOem: 0,
    isHidden: 0,
    parents: ["VM09", "VM11"],
    customizations: ""
  },
  {
    id: "8DIAGNOST",
    type: "marketSegment",
    name: "Clinical Comm Lab",
    legacyName: "Com. Diagnostic Lab.",
    value: "8DIAGNOST",
    isOem: 0,
    isHidden: 0,
    parents: ["VM08", "VM10"],
    customizations: ""
  }
];
